/**
 * Pill rendered next to a job/candidate title when the record was seeded by
 * the workspace auto-onboarding flow (see backend `services/b2b_demo.py`).
 * Demo records behave like normal records — same edit/delete/screening UX —
 * but are excluded from the active-jobs quota.
 */
export default function DemoBadge({ className = '' }) {
  return (
    <span
      className={`inline-flex items-center text-[10px] font-bold uppercase tracking-wider text-accent bg-accent/10 border border-accent/20 rounded-full px-2 py-0.5 ${className}`}
      title="Sample data — feel free to edit or delete"
    >
      Demo
    </span>
  );
}
